// roles.js
const Roles = {
    ADMIN: 1,
    USER: 2,
    EMPLOYEE: 2,
    ACCOUNTANT: 3,
};

export default Roles;
